import styled from 'styled-components'
import { maxWidth } from '@/assets/styles/mixins.css'
import vars from '@/assets/styles/vars'

const WikiSlider = styled.div`
  .swiper-pagination {
    --swiper-pagination-top: 24px;

    ${maxWidth(vars.breakpoints.tablet)`
      --swiper-pagination-top: 14px;
      --swiper-pagination-left: 10px;
  `}
  }
`

WikiSlider.Article = styled.article`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 230px;
  padding: 60px 32px 32px 32px;
  background-color: var(--color-bg-accent);
  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTgwIiBoZWlnaHQ9IjIyMCIgdmlld0JveD0iMCAwIDU4MCAyMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTU4MCAyMjBIMTc3LjVDMTc3LjUgMTQ3IDAgMTIyLjUgMCAwaDIzNS44MjZDMjU5Ljc2IDExMC4xNzMgNDg1LjE4NCA4My4wMDQgNTgwIDEzOS41NjZWMjIweiIgZmlsbD0iI0Y5RkFGQiIvPjwvc3ZnPg==');
  background-size: auto 100%;
  background-position: top right;
  background-repeat: no-repeat;

  ${maxWidth(vars.breakpoints.tablet)`
    padding: 56px 20px 24px 20px;
  `}

  ${maxWidth(vars.breakpoints.mobile)`
    height: 270px;
  `}
`

WikiSlider.Link = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
`

WikiSlider.Title = styled.h3`
  --title-font-size: 20px;
  --title-line-height: 1.4;
  --title-max-lines: 3;

  display: -webkit-box;
  max-height: calc(var(--title-font-size) * var(--title-line-height) * var(--title-max-lines));
  -webkit-line-clamp: var(--title-max-lines);
  -moz-line-clamp: var(--title-max-lines);
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  margin-bottom: 24px;
  font-weight: normal;
  font-size: var(--title-font-size);
  line-height: var(--title-line-height);

  ${maxWidth(vars.breakpoints.mobile)`
    --title-font-size: 18px;
    --title-max-lines: 6;
  `}
`

WikiSlider.More = styled.div`
  display: flex;
  align-items: center;
  font-weight: 900;
  font-size: 14px;
  line-height: 1.2;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-decor);

  svg {
    vertical-align: middle;
    margin-left: 12px;
    transform: rotate(180deg);
    transition: transform 0.3s ease-in-out;
  }

  ${WikiSlider}:hover & > svg {
    transform: translateX(4px) rotate(180deg);
  }
`

export default WikiSlider
